<script setup lang="ts">
import { isPerinstall, step } from "../use/data";
import { showPreinstall, preinstallList } from "../preinstall/preinstall";
import { sendMsg } from "../use/methods";

const pitchOnTemplate = (index: number) => {
  const template = preinstallList[index];
  showPreinstall.value = false;
  sendMsg(template.title, 0, true);
  isPerinstall.value = true;
  step.value = "preinstall-generation";
};
</script>

<template>
  <div class="preinstall-template" v-show="showPreinstall">
    <div font-700 mb-10 pl-8 text-15>推荐案例：</div>

    <div
      v-for="(item, index) in preinstallList"
      :key="index"
      p-10
      rounded-4
      cursor-pointer
      hover:bg="#e5e5e5"
      @click="pitchOnTemplate(index)"
    >
      <div flex-align>
        <CsdImg :src="`/images/ppt/msg.png`" class="mr-8" />
        {{
          item.title.slice(item.title.lastIndexOf("_") + 1, item.title.length)
        }}
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.preinstall-template {
  width: 100%;
  position: absolute;
  background-color: white;
  padding: 20px 10px;
  left: 0;
  top: calc(100% + 5px);
  border-radius: 10px;
  box-shadow: 0px 0px 10px 1px rgba(0, 0, 0, 0.05);
  z-index: 2;
  color: #333333;
  font-size: 13px;
}
</style>
